<template>
  <section class="content">
    <div class="container-fluid">
        <div class="row">

          <div class="col-12">
        
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Pelanggan List</h3>

                <div class="card-tools">
                  
                  
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                <v-data-table :headers="headers" :items="users" :loading="loading"
                    :items-per-page="pagination.itemsPerPage" :page.sync="pagination.page"
                    :server-items-length="totalItems"
                    :footer-props="{ itemsPerPageOptions: [25,50, 100, 200] }" @update:page="fetchPelanggan"
                    @update:items-per-page="changeItemsPerPage">
                    <template #item.no="{ item, index }">
                        {{ (pagination.page - 1) * pagination.itemsPerPage + index + 1 }}
                    </template>
                    <template #item.status="{ item }">
                        <div class="text-center">
                            <span :class="`badge badge-${statusLabel(item.status).color}`" style="padding:8px;font-weight:bold;font-size:12px">
                                {{ statusLabel(item.status).text }}
                            </span>
                        </div>
                    </template>
                    <template #item.actions="{ item }">
                        <div style="white-space: nowrap;">
                            <button class="btn btn-xs btn-danger" title="Proses Approval Pelanggan" @click="openApprovalModal(item)">
                                <i class="fas fa-check-circle"></i> Approval
                            </button>
                        </div>
                    </template>
                    
                </v-data-table>
              </div>
              
            </div>
            <!-- /.card -->
          </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode">Create New Pelanggan</h5>
                    <h5 class="modal-title" v-show="editmode">Edit Pelanggan</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <form @submit.prevent="editmode ? updateProduct() : createProduct()">
                    <div class="modal-body">
                        <div class="form-group">
                            <label>No Pelanggan</label>
                            <input v-model="form.id" type="text" name="id"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('id') }">
                            <has-error :form="form" field="id"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Nama</label>
                            <input v-model="form.nama" type="text" name="nama"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('nama') }">
                            <has-error :form="form" field="nama"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Alamat</label>
                            <input v-model="form.alamat" type="text" name="alamat"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('alamat') }">
                            <has-error :form="form" field="alamat"></has-error>
                        </div>
                        <!--div class="form-group">
                            <label>Kecamatan</label>
                            <select class="form-control" v-model="form.kecamatan_id">
                              <option 
                                  v-for="(kec,index) in kecamatan" :key="index"
                                  :value="index"
                                  :selected="index == form.kecamatan_id">{{ kec }}</option>
                            </select>
                            <has-error :form="form" field="kecamatan_id"></has-error>
                        </div-->
                        <div class="form-group">
                            <label>Email</label>
                            <input v-model="form.email" type="text" name="email"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('email') }">
                            <has-error :form="form" field="email"></has-error>
                        </div>
                        <div class="form-group">
                            <label>HP</label>
                            <input v-model="form.hp" type="text" name="hp"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('hp') }">
                            <has-error :form="form" field="hp"></has-error>
                        </div>
                        <div class="form-group">
                            <label>No KTP</label>
                            <input v-model="form.id" type="text" name="id"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('id') }">
                            <has-error :form="form" field="id"></has-error>
                        </div>
                        <!--div class="form-group">
                            <label>Upload KTP</label>
                            <input v-model="form.url_ktp" type="text" name="url_ktp"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('url_ktp') }">
                            <has-error :form="form" field="url_ktp"></has-error>
                        </div-->
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button v-show="editmode" type="submit" class="btn btn-success">Update</button>
                        <button v-show="!editmode" type="submit" class="btn btn-primary">Tambah</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
    import { EventBus } from './../../event-bus'
    import Surveyor from './Surveyor.vue'
    import FormCalonPelanggan from './FormCalonPelanggan.vue'
    import ApprovalModal from './ApprovalModal.vue'
    export default {
      
        data () {
            return {
                modal: {
                    open: false,
                    title: '',
                    component: null,
                    props: {},
                    width: '400px'
                },
                editmode: false,
                users : [],
                kecamatan: [],
                form: new Form({
                    id : '',
                    nama : '',
                    alamat: '',
                    email:  '',
                    hp: '',
                    kecamatan_id: '',
                }),
                totalItems: 0,
                loading: false,
                pagination: {
                    page: 1,
                    itemsPerPage: 25
                },
                headers: [
                    { text: 'No', value: 'no', sortable: false, width: '30px', align: 'center' },
                    { text: 'No.KTP', value: 'id', sortable: true, width: '90px' },
                    { text: 'Nama', value: 'nama', sortable: true, width: '20%' },
                    { text: 'Alamat', value: 'alamat', sortable: true, class: 'text-center', width: '30%' },
                    { text: 'No.HP', value: 'hp', sortable: true, class: 'text-right', width: '100px' },
                    { text: 'Email', value: 'email', sortable: true, class: 'text-center', width: '100px' },
                    { text: 'Status Approval', value: 'status', sortable: true, class: 'text-center', width: '150px' },
                    { text: 'Aksi', value: 'actions', sortable: false, class: 'text-center', width: '40px' }
                ]
            }
        },
        mounted() {
            this.fetchPelanggan(),
            EventBus.$on('pelanggan:updated', () => {
                this.fetchPelanggan();
            });
        },
        beforeDestroy() {
            // Bersihkan listener saat komponen dihancurkan
            EventBus.$off('pelanggan:updated');
        },
        methods: {
            openFormAddCalonPelanggan(){
                EventBus.$emit('modal:show', {
                    title: `Form Tambah Data Calon Pelanggan `,
                    component: FormCalonPelanggan,
                    props: {},
                    width: '800px',
                    key: `${Date.now()}`
                })
            },
            openFormSurveyor(id) {
                EventBus.$emit('modal:show', {
                    title: `Form Surveyor `,
                    component: Surveyor,
                    props: {id},
                    width: '400px',
                    key: `${Date.now()}`
                })
            },
            openApprovalModal(item) {
                EventBus.$emit('modal:show', {
                    title: `Approval Pelanggan: ${item.nama}`,
                    component: ApprovalModal,
                    props: { id: item.id },
                    width: '950px',
                    key: `${Date.now()}`
                })
            },
            async fetchPelanggan() {
                this.loading = true
                try {
                    const res = await axios.get('api/pelanggan/list', {
                        params: {
                            page: this.pagination.page,
                            per_page: this.pagination.itemsPerPage
                        }
                    })

                    this.users = res.data.data
                    this.totalItems = res.data.total
                } catch (e) {
                    console.error(e)
                } finally {
                    this.loading = false
                }
            },
            changeItemsPerPage(perPage) {
                this.pagination.itemsPerPage = perPage
                this.pagination.page = 1
                this.fetchPelanggan()
            },
            statusLabel(code) {
                const map = {
                    0: { text: 'Penugasan', color: 'primary' },
                    1: { text: 'Survey', color: 'info' },
                    2: { text: 'Validasi Data', color: 'warning' },
                    3: { text: 'Menunggu Approval', color: 'danger' },
                    4: { text: 'Ditolak', color: 'danger' }
                };
                return map[code] || { text: '-', color: 'secondary' };
            }
        }
    }
</script>
